/* 
 * url
 * date: 2019/05/19
 * autor: lixu@myhexin.com
 */

import axios from 'axios'
import jsonp from 'jsonp'

const url = {
    headerUrl: (type) => {
        return `//data.10jqka.com.cn/hsgt/basedata/type/${type}/`
        // return `http://software.myhexin.com/yapi/mock/1366/hsgt/basedata/type/north:south/`
    },

    getFsUrl: (code) => {
        return `//d.10jqka.com.cn/v6/time/${code}/last.js`
    },

    getShareUrl: (type) => {
        /* 
         * @type { string } north: 北向 south: 南向
         */
        return `/hsgt/timedia/type/${type}/`
        // return `http://software.myhexin.com/yapi/mock/1366/hsgt/timedia/type/north:south/`
    },

    // 北向资金图表数据
    // left: "http://software.myhexin.com/yapi/mock/407/hsgt/hsgt/moneyflow/north",
    left: "/dataapi/hk_stock_connect/moneyflow/north",

    getHistoryUrl: (type, date) => {
        return `/hsgt/history/type/${type}/date/${date}`
        // return `http://software.myhexin.com/yapi/mock/890/testing/testing/fundHistory`
    },

    getHistoryIndexUrl: (code, period) => {
        /* 
         * @code { String } 股票代码 (16_1A00001)
         * @period { Number } 周期 (0-9) 0:日 1:周 2:月 8:年 9:季
         */
        return `//d.10jqka.com.cn/v6/line/${code}/${period}1/last3000.js`
    },

    // 概念列表 
    getConceptUrl: `/hsgt/conceptlist/`,

    // 个股榜单url
    getStockListUrl: (type) => {
        return `/hsgt/rating/type/${type}/`
    },

    // 概念成分股url
    getConceptDataUrl: (code) => {
        return `/hsgt/conceptinfo/code/${code}/`
    },

    // 组合图数据
    getComposeDataUrl: (code) => {
        return `/hsgt/cgl/code/${code}/`
    },

    // 获取个股行情数据
    getStockHqUrl: (code, marketid) => {
        return `//d.10jqka.com.cn/v6/line/${marketid}_${code}/01/last500.js`
    }
}

/* 
 * 获取header数据
 */
export const getHeader = (type) => {
    return axios.get(url.headerUrl(type))
}


/* 
 * 获取分时资金数据
 */
export const getShare = (type) => {
    return axios.get(url.getShareUrl(type))
}

/* 
 * 获取北向资金数据
 */
export const getShareLeft = (time) => {
    const noCacheStr = time || new Date().getTime() / 60000 | 0;
    return axios.get(url.left + '/' + noCacheStr);
}

/* 
 * 获取历史走势图数据
 * @type { String } north/source
 * @date { String } day/week/month/quarter/year
 */
export const getHistory = (type, date) => {
    return axios.get(url.getHistoryUrl(type, date))
}

/* 
 * 获取分时指数数据
 * @codeList {string} hs_1A0001,hs_300033 (股票代码, ','分割)
 */
export const getFs = (codeList) => {
    return new Promise((resolve, reject) => {
        jsonp(url.getFsUrl(codeList), {
            name: `quotebridge_v6_time_${codeList.replace(/,/ig, '_')}_last`
        }, (err, data) => {
            if (err) reject(err)
            resolve(data)
        })
    })
}

/* 
 * 获取历史走势指数数据
 */

export const getHistoryIndex = (code, period) => {
    return new Promise((reslove, reject) => {
        jsonp(url.getHistoryIndexUrl(code, period), {
            name: `quotebridge_v6_line_${code}_${period}1_last3000`
        }, (err, data) => {
            if (err) reject(err)
            reslove(data)
        })
    })
}

/* 
 * 获取概念列表
 */

export const getConceptList = () => {
    return axios.get(url.getConceptUrl)
}

/* 
 * 获取个股榜单数据
 */

export const getStockList = (type) => {
    return axios.get(url.getStockListUrl(type))
}

/* 
 * 获取概念成分股数据
 * @code { String } 概念代码
 */

export const getConceptData = (code) => {
    return axios.get(url.getConceptDataUrl(code))
}

/* 
 * 获取组合图数据
 */

export const getComposeData = (code) => {
    return axios.get(url.getComposeDataUrl(code))
}

/* 
 * 获取个股行情数据
 * 现通过WEB行情数据池获取，未使用该接口
 */

/* export const getStockHq = (code, marketid) => {
    return new Promise((reslove, reject) => {
        jsonp(url.getStockHqUrl(code, marketid), {
            name: `quotebridge_v6_line_${marketid}_${code}_01_last500`
        }, (err, data) => {
            if (err) reject(err)
            reslove(data)
        })
    })
} */